module.exports = __webpack_public_path__ + "img/kec-slider1.326d492c.png";